export const CASE_EVENTS_TABLE_CONSTANTS = {
  tableName: "case_events",
  className: "CaseEvent",
  exportTableName: "CaseEventsTable",
  header: "Events",
  headerIcon: "bolt",
};
